import { Subject } from '@/hooks/useSubject';

export const getTags: (
    subject: Subject,
) => {
    key: string;
    value?: string;
}[] = (subject) =>
    subject.tags.map((tag) => {
        // Tag is a string that has a key, but can also contain a value like this: key=value
        const [key, value] = tag.split('=');
        return { key, value };
    });

export const hasTagWithKey: (subject: Subject, key: string) => boolean = (
    subject,
    key,
) => subject.tags.some((tag) => tag.startsWith(`${key}=`));

export const getTagValueByKey: (
    subject: Subject,
    key: string,
) => string | undefined = (subject, key) => {
    const tag = subject.tags.find((tag) => tag.startsWith(`${key}=`));
    return tag ? tag.split('=')[1] : undefined;
};
